import { Backdrop, Button, Checkbox, Chip, FormControlLabel, Grid, IconButton, Switch, Typography } from "@mui/material";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import * as yup from "yup";
import CustomDataGrid from "../../../../../components/dataTable/customDataGrid";
import CustomTextField from "../../../../../components/utils/input/customTextField";
import Modal from "../../../../../components/utils/modal/modal";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import axios from "axios";
import { Delete, EditNote } from "@mui/icons-material";
import DeletePage from "../../../../../components/utils/deleteModal/deletePage";
import _ from "lodash";
import Loader from "../../../../../components/loader/loader";
import { Helmet } from "react-helmet-async";

const PaymentType = () => {
  const dispatch = useDispatch()
  const pageOption = [10, 25, 50, 100];
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  // const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
  const [pageCount, setPageCount] = useState(0);
  const [search, setSearch] = useState("");
  const [open, setOpen] = useState(false);
  const [data, setData] = useState([])
  const [isEdit, setIsEdit] = useState(false)
  const [openDialog, setOpenDialog] = useState(false)
  const [activeId, setActiveId] = useState(null)
  const [active, setActive] = useState(false)
  const [isLoader, setIsLoader] = useState(false); //loader

  const validationSchema = yup.object({
    payName : yup.string().required("Pay Name is required field"),
    payKey: yup.string().required("Pay key is required field")
  })
  
  const formik = useFormik({
    initialValues :{
        payName : "",
        payKey:""
    },
    validationSchema:validationSchema,
    onSubmit: isEdit ? handleUpdate : handleCreate
  })
  const onCreate = () => {
    setOpen(true)
    formik.resetForm()
    setIsEdit(false)
  }
  function handleCreate(){
    const payPost = {
        pay_type_name: formik.values.payName,
        pay_type_key: formik.values.payKey,
        is_active : active
    }
    setIsLoader(true);
    axios.post('/v1/pay_type_master', payPost)
    .then(res=>{
      console.log(res)
      setOpen(false)
      getUomData()
      setIsLoader(false);
      dispatch(setSnackbar(true, 'success', 'Created Successfully'))
    })
    .catch(err=>{
      dispatch(setSnackbar(true, 'error',err.response.data.errors[0].message))
      console.log(err)
      setIsLoader(false);
    })
  }
  function onEdit(e){
    console.log(e)
    formik.setFieldValue('payName',e.payName)
    formik.setFieldValue('payKey',e.payKey)
    setIsEdit(true)
    setOpen(true)
    setActive(e.isActive)
    setActiveId(e.id)
    }
    function handleUpdate(){
      const payUpdate = {
        pay_type_name: formik.values.payName,
        pay_type_key: formik.values.payKey,
        is_active : active
      }
      setIsLoader(true);
      axios.put(`/v1/pay_type_master/${activeId}`, payUpdate)
      .then(res=>{
        setOpen(false)
        console.log(res)
        getUomData()
        setIsLoader(false);
        dispatch(setSnackbar(true, 'success', 'Updated Successfully'))
      })
      .catch(err=>{
        dispatch(setSnackbar(true, 'error',err.response.data.errors[0].message))
        console.log(err)
        setIsLoader(false);
      })
    console.log('update')
    }
    function OnDelete(id){
      setOpenDialog(true)
      setActiveId(id)
    }  
    const handleDelete = () =>{
      setIsLoader(true);
      axios.delete(`/v1/pay_type_master/${activeId}`)
      .then(res=>{
        setOpenDialog(false)
        getUomData()
        console.log(res)
        dispatch(setSnackbar(true, 'success', 'Deleted Successfully'))
        setIsLoader(false);
        setOpen(false)
      })
      .catch(err=>{
        dispatch(setSnackbar(true, 'error',err.response.data.errors[0].message))
        console.log(err)
        setIsLoader(false);
      })
    console.log('fasdf')
    }
  const columns = [
    {
      field: "sno",
      headerName: "S.no",
      flex: 1,
      minWidth: 70,
      maxWidth: 100,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "payName",
      headerName: "Pay Name",
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "payKey",
      headerName: "Pay key",
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "active",
      headerName: "Status",
      flex: 1,
      disableExport: true ,
      headerAlign: "center",
      align: "center",
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => (
        <div className="">
        <Chip size='small' color={params.row.isActive ? 'success' : 'error'} label={params.row.isActive ? 'Active' : 'Inactive'}/>
        </div>
      )
    },
    {
      field: 'action',
      headerName: 'Action',
      flex: 1,
      disableExport: true ,
      minWidth: 100,
      headerAlign: "center",
      align: "center",
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => (
        <div className='flex justify-center w-full'>
          <IconButton onClick={()=>onEdit(params.row)} >
            <EditNote sx={{color:"#1972d2",fontSize:22}}/>
          </IconButton>
          <IconButton onClick={() => OnDelete(params.id)}>
            <Delete sx={{color:"red",fontSize:22}}/>
          </IconButton>
        </div>
      ),
    },
  ];
  const rows = _.map(data, (val,idx) => ({
    id:val.id,
    sno:++idx,
    payName:val.pay_type_name,
    payKey:val.pay_type_key,
    isActive:val.is_active

  }))
  console.log(data)
  const props = {
    rows: rows,
    columns: columns,
    search: search,
    setSearch: setSearch,
    page: page,
    setPage: setPage,
    rowsPerPage: rowsPerPage,
    setRowsPerPage: setRowsPerPage,
    pageCount: pageCount,
    pageOption: pageOption,
  };
  const getUomData = () =>{
    setIsLoader(true);
    // const url = `/v1/units/${rowsPerPage}/${page + 1}`
    // const searchUrl = `/v1/units/${rowsPerPage}/${page + 1}/${search}`
    // axios.get(search === '' ? url : searchUrl)
    axios.get(`/v1/pay_type_master`)
    .then(res=>{
        console.log(res)
      setData(res.data)
    //   setPageCount(res.data.meta.pagination.total)
      setIsLoader(false);
    })
    .catch(err=>{
      console.log(err)
      setIsLoader(false);
      dispatch(setSnackbar(true, 'error', err.response.data.errors[0].code))
    })
  }
  useEffect(()=>{
    getUomData()
    },[])
    console.log(data)
  return (
    <Grid className="">
      <Helmet>
        <title>Payment Type</title>
      </Helmet>
      <Typography variant="h5">Payment Type</Typography>
      {!open &&
  <Grid className='flex justify-end'>
    <Button variant='contained' size='small' onClick={onCreate}>Create New</Button>
</Grid>}
 {open &&
        <Modal onClose={setOpen} formik={formik} onSave={formik.handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={4} lg={3}  >
            <CustomTextField id='payName' value={formik.values.payName} title='Pay type name' multiple={false} placeholder='Pay type name' onchange={formik.handleChange} errorMsg={formik.touched.payName && Boolean(formik.errors.payName)} helperText={formik.touched.payName && formik.errors.payName}/>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}  >
            <CustomTextField id='payKey' value={formik.values.payKey} title='Pay type key' multiple={false} placeholder='Pay type key' onchange={formik.handleChange} errorMsg={formik.touched.payKey && Boolean(formik.errors.payKey)} helperText={formik.touched.payKey && formik.errors.payKey}/>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3} className="flex items-center">
            <FormControlLabel  control={<Checkbox checked={active} onChange={()=>setActive(!active)}/>} label="Active" />
            </Grid>
            
          </Grid>
        </Modal>
      } 
      <Grid className="bg-white rounded-md p-2 my-3">
        <CustomDataGrid props={props} />
      </Grid>
      <Backdrop open={openDialog} sx={{zIndex:1350}}>
  <DeletePage onCancel={setOpenDialog} onSubmit={handleDelete}/>
</Backdrop>
{/* <Loader isLoader={isLoader} /> */}
    </Grid>
  );
};

export default PaymentType;
